var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZapCircle = function SvgZapCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11.297-7.455A1 1 0 0 1 13 5.5v4h3.013c.217 0 .442 0 .629.017.185.017.518.062.818.29a1.5 1.5 0 0 1 .588 1.119c.018.376-.133.676-.224.838a7 7 0 0 1-.342.528l-4.658 6.775A1 1 0 0 1 11 18.5v-4H7.987c-.217 0-.442 0-.629-.017-.185-.017-.518-.062-.818-.29a1.5 1.5 0 0 1-.588-1.119c-.018-.376.133-.676.224-.838a7 7 0 0 1 .362-.556l4.638-6.747a1 1 0 0 1 1.12-.388M8.4 12.5H12a1 1 0 0 1 1 1v1.78l2.599-3.78H12a1 1 0 0 1-1-1V8.72z",
    clipRule: "evenodd"
  })));
};
export default SvgZapCircle;